import { Live } from '@/app/entities/Live'
import { createContext, PropsWithChildren, useContext, useState } from 'react'
import useLiveForm from '../hooks/useLocalStep'

interface LiveFormContextProps extends ReturnType<typeof useLiveForm> {
  openCreateLiveModal: () => void
  closeCreateLiveModal: () => void
  setIsLiveModalOpen: (value: boolean) => void
  isLiveModalOpen: boolean
  selectedLive: Live | null
  setSelectedLive: (live: Live | null) => void
}

const LiveFormContext = createContext<LiveFormContextProps | null>(null)

export const LiveFormProvider = ({ children }: PropsWithChildren) => {
  const [selectedLive, setSelectedLive] = useState<Live | null>(null)
  const [isLiveModalOpen, setIsLiveModalOpen] = useState<boolean>(false)
  const form = useLiveForm()

  const openCreateLiveModal = () => {
    if (form.localDontShowAgain) form.setStep(1)
    else form.setStep(0)
    setIsLiveModalOpen(true)
  }

  const closeCreateLiveModal = () => {
    setSelectedLive(null)
    setIsLiveModalOpen(false)
  }

  const handleSetIsLiveModalOpen = (value: boolean) => setIsLiveModalOpen(value)

  return (
    <LiveFormContext.Provider
      value={{
        openCreateLiveModal,
        closeCreateLiveModal,
        isLiveModalOpen,
        setIsLiveModalOpen: handleSetIsLiveModalOpen,
        selectedLive,
        setSelectedLive,
        ...form,
      }}
    >
      {children}
    </LiveFormContext.Provider>
  )
}

export const useLiveFormContext = () => {
  const context = useContext(LiveFormContext)

  if (!context) {
    throw new Error('LiveFormContext not found')
  }

  return context
}
